import { useCallback, useEffect } from "react"
import { useAppDispatch, useAppSelector } from "../hooks"
import { closeModal, selectBooking, selectSelectedBooking, selectSelectedBookingIndex } from "./mugshotsSlice"
import { useSortedBookings } from "../bookings/hooks"


export const useSelectedBooking = () => {
  const bookingSelection = useAppSelector(selectSelectedBooking)
  return bookingSelection
}

export const useBookingIsSelected = () => {
  const bookingSelection = useSelectedBooking()
  return bookingSelection !== null
}

export const useSelectedIndex = () => {
  const index = useAppSelector(selectSelectedBookingIndex)
  return index
}

export interface MugshotModalControls {
  next: () => void;
  previous: () => void;
  close: () => void;
}

export const useModalControls = (): MugshotModalControls => {
  const dispatch = useAppDispatch()
  const bookings = useSortedBookings()
  const index = useSelectedIndex()

  const next = useCallback(() => {
    if (index !== null) {
      let nextIndex = index + 1
      if (nextIndex >= bookings.length) { nextIndex = 0 }
      dispatch(selectBooking({
        booking: bookings[nextIndex],
        index: nextIndex,
      }))
    }
  }, [bookings, index, dispatch])

  const previous = useCallback(() => {
    if (index !== null)
    {
      let previousIndex = index - 1
      if (previousIndex < 0) { previousIndex = bookings.length - 1 }
      dispatch(selectBooking({
        booking: bookings[previousIndex],
        index: previousIndex,
      }))
    }
  }, [bookings, index, dispatch])

  const close = useCallback(() => {
    dispatch(closeModal())
  }, [dispatch])


  return { next, previous, close }
}

export const useModalOnKeyUp = () => {
  const { next, previous, close } = useModalControls()

  const onKeyUp = useCallback((event: KeyboardEvent): any => {
    console.log('key up', event.key)
    switch (event.key) {
      case 'ArrowRight':
        next()
        break
      case 'ArrowLeft':
        previous()
        break
      case 'Escape':
        close()
        break
    }
  }, [next, previous, close])

  useEffect(() => {
    document.addEventListener('keyup', onKeyUp)
    return () => {
      document.removeEventListener('keyup', onKeyUp)
    }
  }, [onKeyUp])
}